import React from 'react'
import { EmtTypography, EmtSwitch, EmtIcon } from 'emt-components-v2'
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import { SxProps } from '@mui/material/styles'

type SwitchChoice = {
  slug: string
  name: string
  description?: string
  iconClass?: string
}

type Props = {
  handleChoice: (typeSlug: string, value: boolean) => void
  selectedChoices: Record<string, boolean>
  choices: SwitchChoice[]
  title: string
  color?: string
}

const SwitchChoices: React.FC<Props> = ({ handleChoice, selectedChoices, choices, title, color = '#AE59C6' }) => {
  const formControlLabelSx: SxProps = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    marginRight: 0,
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        '& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': { backgroundColor: `${color}!important` },
      }}
    >
      <EmtTypography variant="body1" fontWeight="bold">
        {title}
      </EmtTypography>
      {choices.map((choice) => (
        <FormControlLabel
          key={choice.slug}
          control={
            <EmtSwitch
              checked={selectedChoices[choice.slug] || false}
              size="medium"
              onChange={(e) => {
                handleChoice(choice.slug, e.target.checked)
              }}
            />
          }
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {choice.iconClass && <EmtIcon sx={{ width: 'unset' }} className={choice.iconClass} />}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                <EmtTypography variant="body1" lineHeight={1} color="greyGradient.main">
                  {choice.name}
                </EmtTypography>
                <EmtTypography variant="body2" lineHeight={1} color="greyGradient.main">
                  {choice.description}
                </EmtTypography>
              </Box>
            </Box>
          }
          sx={formControlLabelSx}
        />
      ))}
    </Box>
  )
}

export default SwitchChoices
